(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    const steps = [...root.querySelectorAll('[data-step]')];
    if (!form || !steps.length) {
      root.querySelector('.dp-success')?.focus();
      return;
    }
    const strings = JSON.parse(root.querySelector('[data-package-text]').textContent);
    const previous = root.querySelector('[data-back]');
    const next = root.querySelector('[data-next]');
    const submit = root.querySelector('[data-submit]');
    const error = root.querySelector('[data-form-error]');
    const packageError = root.querySelector('[data-package-error]');
    const answers = [...form.querySelectorAll('[data-answer]')];
    const garments = answers.filter((field) => field.dataset.answer === 'garments');
    let current = 0;
    let submitting = false;
    form.noValidate = true;
    root.classList.add('is-enhanced');
    root.querySelector('[data-progress]').hidden = false;

    const isExisting = () => form.querySelector('[data-answer="customer_type"]:checked')?.value === 'existing';
    const packageValid = () => {
      const chosen = garments.filter((input) => input.checked).map((input) => input.value);
      return chosen.includes('complete') || (chosen.length >= 2 && chosen.some((value) => value !== 'shoes'));
    };
    const collect = () => {
      const groups = new Map();
      for (const input of answers) {
        if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) continue;
        const value = input.tagName === 'SELECT' ? (input.value ? input.selectedOptions[0].textContent.trim() : '') : (input.dataset.valueLabel || input.value.trim());
        if (!value) continue;
        const key = input.dataset.answer;
        if (!groups.has(key)) groups.set(key, { label: input.dataset.label, values: [] });
        groups.get(key).values.push(value);
      }
      return [...groups.values()];
    };
    const updateOffer = () => {
      const existing = isExisting();
      root.querySelector('[data-offer]').hidden = existing;
      root.querySelector('[data-existing]').hidden = !existing;
      submit.textContent = existing ? strings.existing : strings.submit;
      root.querySelector('[data-request-offer]').value = existing ? strings.existing_offer : strings.new_offer;
    };
    const updateReview = () => {
      const review = root.querySelector('[data-review]');
      review.replaceChildren();
      for (const entry of collect()) {
        const dt = document.createElement('dt');
        const dd = document.createElement('dd');
        dt.textContent = entry.label;
        dd.textContent = entry.values.join(', ');
        review.append(dt, dd);
      }
    };
    const showStep = (index, focus = true) => {
      current = index;
      steps.forEach((step, i) => { step.hidden = i !== current; });
      previous.hidden = current === 0;
      next.hidden = current === steps.length - 1;
      submit.hidden = current !== steps.length - 1;
      root.querySelector('[data-current]').textContent = String(current + 1);
      root.querySelector('[data-step-name]').textContent = steps[current].querySelector('h2').textContent;
      root.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(current + 1));
      root.querySelector('[data-progress-fill]').style.width = `${((current + 1) / steps.length) * 100}%`;
      error.hidden = true;
      if (current === steps.length - 1) updateReview();
      if (focus) {
        steps[current].querySelector('h2').focus({ preventScroll: true });
        root.querySelector('.dp-card').scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    };
    const validate = (index) => {
      const invalid = [...steps[index].querySelectorAll('input,select,textarea')].find((input) => !input.checkValidity());
      if (invalid) {
        showStep(index);
        error.hidden = false;
        invalid.reportValidity();
        return false;
      }
      if (index === 2 && !packageValid()) {
        showStep(index);
        packageError.hidden = false;
        garments[0].focus();
        return false;
      }
      return true;
    };
    previous.addEventListener('click', () => showStep(Math.max(0, current - 1)));
    next.addEventListener('click', () => { if (validate(current)) showStep(current + 1); });
    form.addEventListener('change', (event) => {
      const target = event.target;
      if (target.dataset.answer === 'garments') {
        if (target.checked && target.value === 'complete') garments.forEach((input) => { if (input !== target) input.checked = false; });
        else if (target.checked) garments.find((input) => input.value === 'complete').checked = false;
        packageError.hidden = packageValid();
      }
      updateOffer();
      if (current === steps.length - 1) updateReview();
    });
    form.addEventListener('input', () => {
      error.hidden = true;
      if (current === steps.length - 1) updateReview();
    });
    form.addEventListener('submit', (event) => {
      if (submitting) { event.preventDefault(); return; }
      if (current < steps.length - 1) {
        event.preventDefault();
        if (validate(current)) showStep(current + 1);
        return;
      }
      for (let index = 0; index < steps.length; index++) {
        if (!validate(index)) { event.preventDefault(); return; }
      }
      updateOffer();
      root.querySelector('[data-request-body]').value = [
        'Dutsch Workwear — Kledingpakket op maat',
        `Language: ${root.dataset.locale}`,
        root.querySelector('[data-request-offer]').value,
        ...collect().map((entry) => `${entry.label}: ${entry.values.join(', ')}`)
      ].join('\n\n');
      submitting = true;
      submit.setAttribute('aria-busy', 'true');
    });
    window.addEventListener('pageshow', () => {
      submitting = false;
      submit.removeAttribute('aria-busy');
    });
    updateOffer();
    showStep(0, false);
  };
  const initAll = () => document.querySelectorAll('[data-package-builder]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
